import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { TreeViewItemComponent } from "./tree-view-item/tree-view-item.component";
import { TreeViewItemTitleComponent } from "./tree-view-item-title/tree-view-item-title.component";
import { IconModule } from "../icon/icon.module";

@NgModule({
	imports: [CommonModule, IconModule],
	declarations: [TreeViewItemComponent, TreeViewItemTitleComponent],
	exports: [TreeViewItemComponent, TreeViewItemTitleComponent],
})
export class TreeViewModule {}
